import React from "react";

function Skills() {
  return (
    <div>
      <div className="skill" id="skills">
        <h1>Skills</h1>
        <ul className="skill-list">
          <li> GIT </li>
          <li> HTML/CSS</li>
          <li>JAVASCRIPT/TYPESCRIPT</li>
          <li>MYSQL/MongoDB/Firebase/PostgreSQL</li>
          <li>Node.js(ExpressJS)</li>
          <li>Node.js(NestJS)</li>
          <li>React/Next</li>
          <li>Angular</li>
          <li>React-native</li>
          <li>Vue</li>
          <li>PHP( Laravel )</li>
          <li>Java Springboot</li>
        </ul>
      </div>
    </div>
  );
}

export default Skills;
